import React from "react";
import { cn } from "../../../common/u1/cn";
import { EnterprisePicker } from "./EnterprisePicker";

/* The Partner Program's title block and its "tracking as" picker. */
export const EnterpriseHeader = ({
  title = "Partner Program",
  intro = "Live credit visibility on the buyers you extend credit to, tracked in one place.",
  enterprises = [],
  selected,
  /* Accepted and unused: the picker's subtitle carries it per programme now.
     Kept in the signature so a caller still passing it is not silently
     dropping something — see the note above. */
  // eslint-disable-next-line no-unused-vars
  credits,
  onSelect = () => {},
  className = "",
}) => {
  return (
    <div className={cn("flex flex-wrap items-start justify-between gap-4", className)}>
      <div className="min-w-0">
        <h2 className="m-0 text-[26px] font-bold tracking-[-.01em] text-[var(--ink)] font-sans">
          {title}
        </h2>
        {intro && (
          <p className="mt-1.5 mb-0 max-w-[560px] text-[14.5px] leading-[1.5] text-[var(--ink-2)] font-sans">
            {intro}
          </p>
        )}
      </div>

      {/* Only shown when there is an enterprise to pick — transcribed guard,
          and the picker enforces it too. */}
      <EnterprisePicker
        className="w-full shrink-0 sm:w-[320px]"
        enterprises={enterprises}
        selected={selected}
        onSelect={onSelect}
      />
    </div>
  );
};

export default EnterpriseHeader;
